/**
 * @file        src/pages/insurance/CorporateBookingList.jsx
 * @description Corporate Insurance → Insurance List. The same list, filters and
 *              actions as the B2C screen (BookingList.jsx), fixed to
 *              audience=b2b, rather than forking the page — the same
 *              relationship flight/CorporateBookingList has to its B2C twin.
 * @author      Kinetika Labs
 * @created     2026-09-22
 * @changelog
 *   - 2026-09-22 Claude — Initial (Corporate Insurance visibility).
 */
import BookingList from './BookingList';

export default function CorporateInsuranceBookingList() {
  return (
    <BookingList
      title="Corporate Insurance List"
      subtitle="Corporate Insurance · travel insurance policies"
      audience="b2b"
    />
  );
}
